import { useState } from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import { ArrowUpRightIcon } from 'icons';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

interface IResultItem {
  score: string;
  id: string;
  name: string;
  description: string;
  universities: any[];
}

interface IProps {
  results: IResultItem[];
  onFieldSelect: (fieldId: string | null) => void;
}

const OTMResults = ({ results, onFieldSelect }: IProps) => {
  const t = useTranslations();
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { push } = useRouter();

  const handleSelect = (id: string) => {
    setSelectedId(id);
  };

  return (
    <div className="mt-5">
      <div className="m-3 rounded-xl bg-white p-4 shadow-sm md:m-0">
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <div className="text-md font-medium">{t('Yonalishni_tanlang')} 😊️</div>
      </div>

      <div className="mt-3 grid grid-cols-1 gap-4 p-3 md:grid-cols-2 md:p-0">
        {results.map((result, index) => {
          const isSelected = selectedId === result.id;

          return (
            <div
              key={result.id}
              onClick={() => handleSelect(result.id)}
              className={classNames('rounded-xl border-2', {
                'border-transparent': !isSelected,
                'border-green-500': isSelected
              })}
            >
              <div
                className={classNames(
                  'h-full cursor-pointer rounded-xl border bg-white p-4 transition-all duration-200',
                  {
                    'border-transparent': isSelected,
                    'border-gray-200': !isSelected
                  }
                )}
              >
                <div className="flex justify-between gap-10">
                  <div className="space-y-2">
                    <h2 className="text-lg font-semibold">
                      <span className="text-green-500">{index + 1}. </span>
                      {result.name}
                    </h2>
                    <p className="mb-2 line-clamp-2 break-words text-sm text-gray-400">{result.description}</p>
                  </div>
                  <div className="mr-5 mt-3">
                    <ArrowUpRightIcon />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className='p-0 sm:p-3 md:p-0'>
        <div className="shadow-xs absolute bottom-0 min-h-20 max-h-20 left-0 mt-5 flex w-full items-center justify-between rounded-t-4xl sm:rounded-xl bg-white p-4 sm:static sm:mt-5">
          <Button
            onClick={() => push('/')}
            className="!duration-400 !rounded-lg !border-none !bg-red-50 !px-8 !py-5 !font-medium !text-red-500 !transition !ease-in-out hover:!bg-red-500 hover:!text-white"
          >
            {t('yakunlash')}
          </Button>
          <Button
            disabled={!selectedId}
            onClick={() => onFieldSelect(selectedId)}
            className={classNames('!rounded-lg !border-none !px-8 !py-5 !font-medium', {
              '!bg-green-500 !text-white': selectedId,
              '!bg-gray-100 !text-gray-400': !selectedId
            })}
          >
            {t('keyingisi')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OTMResults;
